import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-mini-ts';

@Component({
  selector: 'app-re-schedule-item',
  templateUrl: './re-schedule-item.component.html',
  styleUrls: ['./re-schedule-item.component.scss']
})
export class ReScheduleItemComponent implements OnInit {


  reschduleSlotRequest = {};
  reschduleDynamicSlotRequest = {};
  slotResponse = [];
  slotTimingInfo: string = null;
  from_date: any;
  reasonType: string = "";
  subReasonType: string = "";
  statusComment: string = "";
  isFormValid: Boolean = false;
  preferredTime: string = "";
  preferredTimeResponse = [];
  getSlotTimeInfo: string = null;

  @Input() isConfirmedOrder;
  @Input() isReScheduleOrder;
  @Input() isReqReScheduleOrder;
  @Input() isReqCancelledOrder;
  @Input() isReqStatus;
  reason: string = null;
  @Input() pincode;
  @Input() mode_of_service;
  @Input() order_id;
  @Input() order_status;
  @Input() delivery_lng;
  @Input() delivery_lat;
  @Input() orderObj;
  @Input() business_id;
  @Input() org_code;
  @Input() tenant_code;
  @Input() service_did;
  @Input() patient_gender;
  @Input() patient_mrn;
  @Input() patient_age;
  @Input() preferred_officer;
  @Input() preferred_time;
  @Input() isCancelOrder;
  @Input() total_amount;
  @Input() isForceReschedule;

  orderCancelTypes: [];
  orderCancelSubTypes: [];
  amount:any;
  maxAmount: number;
  msg:string ="";
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  private apiKey= environment.apiKey;
  minDate = undefined;
  constructor(

    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { 
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

  }
  time:any;
  meridian=true;
  ngOnInit(): void {
    console.log(this.order_id);
    //console.log(this.apiKey);
    //console.log("isConfirmedOrder=" + this.isConfirmedOrder);
    //console.log("isReScheduleOrder=" + this.isReScheduleOrder);
    // if(this.order_status == 26 || this.order_status ==1001)
    // {
    //   this.isConfirmedOrder = true;
    // }else{
    //   this.isReScheduleOrder = true;
    // }
    this.maxAmount=this.total_amount;
    if (this.isReScheduleOrder || this.isReqReScheduleOrder || this.isReqCancelledOrder || this.isCancelOrder) {
     //this.from_date = this.orderObj.order.patientinfo.final_delivery_date;
    // this.from_date = {year: 2019, month: 2, day: 26 };
     
      this.getAllCancelationReasons();
    }
    this.selectedDate(this.orderObj.order.patientinfo.scheduled_date);
    if(!this.isForceReschedule){
      this.getSolts();
    }else{
      this.time = {
       "hour" :moment(this.orderObj.order.patientinfo.scheduled_date, 'YYYY-MM-DD HH:mm:ss').hour(),
        "minute": moment(this.orderObj.order.patientinfo.scheduled_date, 'YYYY-MM-DD HH:mm:ss').minute(),
        "second": 0
      };
    }
  }
  forceReschedule(){
    console.log(moment( this.from_date).format("YYYY-MM-DD")+" "+moment(this.time).format("HH:mm:ss"))
    console.log(this.time)
    let fromDateValue = this.from_date.year + "-" + this.from_date.month + "-" + this.from_date.day;
    let payload={
      "actionById": window.localStorage.getItem('actionById'),
      // "channelCode": "2",
      "actionByName":window.localStorage.getItem('actionByName'),
      "order_ids": [this.order_id],
      "action": "OMS/api/operation.php/v1/schedule/date/update",
      "type": "post",
      "new_scheduled_date":moment(fromDateValue).format("YYYY-MM-DD")+" "+moment(this.time).format("HH:mm:ss"),
      "reason":this.reason,
      "isInternalCall":1
    }
    this.SpinnerService.show()
    this.omsServiceService.omsCommonMethod(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
      if(res && res.status == '1'){
        this.toastr.success(res["message"]);
        this.modal.close()
      }else{
        this.toastr.error(res["message"]);
      }

    }) 
  }
  getDate(val: any) {

    let fromDateValue = val.year + "-" + val.month + "-" + val.day;
    let selectedDate = this.sharedService.getStringDate(new Date(fromDateValue));
    return this.getData(selectedDate);
  }

  getSolts()
  {
   //console.log(this.from_date);
   let fromDateValue = this.from_date.year + "-" + this.from_date.month + "-" + this.from_date.day;
   let selectedDate = this.sharedService.getStringDate(new Date(fromDateValue));
   return this.getData(selectedDate);
  }
  getData(dateEntered: string) {
    //this.reschduleSlotRequest["api_key"] = "91ADEF-F14F-4422-95211-1224THE";
    //this.reschduleSlotRequest["api_key"] = "31DEM-D42WA-P1144-ERD131-1ERT1";
    // this.orderRequest["from_date"] = dateEntered;
    this.reschduleSlotRequest["api_key"] = this.apiKey;
    this.reschduleSlotRequest["from_date"] = dateEntered;
    this.reschduleSlotRequest["to_date"] = dateEntered;
    this.reschduleSlotRequest["engagement_level"] = this.mode_of_service;

    // this.reschduleSlotRequest["role_id"] = this.constantsService.ROLE_ID;
    this.reschduleSlotRequest["role_id"] = window.localStorage.getItem('role');

    this.reschduleSlotRequest["pin_code"] = this.pincode;
    this.reschduleSlotRequest["type"] = "post";
    this.reschduleSlotRequest["business_id"]=this.business_id;
    this.reschduleSlotRequest["tenant_code"] = this.tenant_code;
    this.reschduleSlotRequest["organization_code"] = this.org_code;

    // this.reschduleDynamicSlotRequest["type"] = "post";
    this.reschduleDynamicSlotRequest["from_date"] = dateEntered;
    this.reschduleDynamicSlotRequest["business_id"] = this.business_id;
    this.reschduleDynamicSlotRequest["patient_gender"]=this.patient_gender;
    this.reschduleDynamicSlotRequest["pin_code"] = this.pincode;
    this.reschduleDynamicSlotRequest["patient_mrn"] = this.patient_mrn;
    this.reschduleDynamicSlotRequest["patient_age"] = this.patient_age;
    this.reschduleDynamicSlotRequest["order_latitude"] = this.delivery_lat;
    this.reschduleDynamicSlotRequest["order_longitude"]=this.delivery_lng;
    this.reschduleDynamicSlotRequest["no_of_days"] = 1;
    this.reschduleDynamicSlotRequest["source_system"] = "V5";
    this.reschduleDynamicSlotRequest["service_did"] =this.service_did;
    this.reschduleDynamicSlotRequest["preferred_officer"] = this.preferred_officer;
    this.reschduleDynamicSlotRequest["engagement_level"]=this.mode_of_service;
    this.reschduleDynamicSlotRequest["tenant_code"] = this.tenant_code;
    this.reschduleDynamicSlotRequest["organization_code"] = this.org_code;
    if(this.business_id == 10 || this.business_id == 1 ){
      this.reschduleDynamicSlotRequest["preferred_officer"] = this.orderObj.order.patientinfo.doctorId;
    }

    // this.reschduleDynamicSlotRequest["next_immediate_slots"] = 4;
    let dateTimesplit = this.preferred_time.slice(11);
    dateTimesplit = dateTimesplit.split('.')
     this.preferredTime = dateTimesplit[0]
    // this.preferredTime = "11:05:00";

if((this.business_id == 4 || this.business_id == 3) && this.mode_of_service == 2){
    this.omsServiceService.getOrderDate(this.reschduleSlotRequest).subscribe(
      (res:any) => {
        //console.log(res["slots"][dateEntered]);
        // this.OrderDateRes = res["slots"][dateEntered];
        // this.slotResponse = res["slots"][dateEntered];
        if(res && res.status =='1' ){
          res.slots.map((data:any)=>{
            if(data.date ==dateEntered ){
              this.slotResponse = data.slot_data;
            }
          })
        }
        if(this.slotResponse  !=null && this.slotResponse  !=undefined)
        {
          this.slotResponse =this.slotResponse.filter(data=>data.is_booked==0);
          this.preferredTimeResponse =this.slotResponse.filter(data=>data.from_time==this.preferredTime);
        }
        this.slotTimingInfo = this.preferredTimeResponse[0];
        // console.log('getting preferredTime'+ this.preferredTime );
        this.getSlotTimeInfo = this.preferredTime+'';
      });
}else{
  // console.log('getting dynamic solt start'+ JSON.stringify(this.reschduleDynamicSlotRequest));
  this.SpinnerService.show()   
  this.omsServiceService.getOrderDynamicDate(this.reschduleDynamicSlotRequest).subscribe(
      (res:any) => {
        this.SpinnerService.hide()
        //console.log(res["slots"][dateEntered]);
        // this.OrderDateRes = res["slots"][dateEntered];
        if(res && res.status =='1' ){
          res.slots.map((data:any)=>{
            if(data.date ==dateEntered ){
              this.slotResponse = data.slot_data;
            }
          })
        }
        if(this.slotResponse  !=null && this.slotResponse  !=undefined)
        {
          this.slotResponse =this.slotResponse.filter(data=>data.is_booked==0);
          this.preferredTimeResponse =this.slotResponse.filter(data=>data.from_time==this.preferredTime);
        }
        this.slotTimingInfo = this.preferredTimeResponse[0];
        this.getSlotTimeInfo = this.preferredTime+'';
        console.log('getting dynamic solt'+ JSON.stringify(this.slotResponse));
      });
}
  }


  submitModalData() {
    //console.log('slotTimingInfo -> ' + this.slotTimingInfo);
    console.log('from_date -> ' + JSON.stringify(this.slotTimingInfo));
    if (this.isConfirmedOrder) {
      this.submitConfirmedOrder(this.from_date, this.slotTimingInfo);
    } else {
      this.reScheduleOrder(this.from_date, this.slotTimingInfo);
    }
  }

  submitConfirmedOrder(dateEntered, slotTiming) {
      console.log('slotTiming -> ', slotTiming);
    if (slotTiming != "" && slotTiming != null && slotTiming != undefined) {
      this.msg="";
      this.isFailureMsg=false;
      this.isSuccessMsg=false;
      this.SpinnerService.show();
      let orderConfirmationRequest = {};
      let fromDate = dateEntered;
      let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
      let scheduledDate = this.sharedService.getStringDate(new Date(fromDateValue));
      orderConfirmationRequest["method"] = "OMS/api/operation.php/v1/order/change/status";
      orderConfirmationRequest["type"] = "POST";
      orderConfirmationRequest["order_id"] = [this.order_id];
      orderConfirmationRequest["actionById"] = window.localStorage.getItem('actionById');
      orderConfirmationRequest["actionByName"] = window.localStorage.getItem('actionByName');
      orderConfirmationRequest["source"] = this.constantsService.SOURCE;
      orderConfirmationRequest["comment"] = "Order confirmation";
      orderConfirmationRequest["reason"] = this.reason;
      orderConfirmationRequest["scheduled_date"] = scheduledDate;
      orderConfirmationRequest["start_time"] = slotTiming.from_time;
      // orderConfirmationRequest["start_time"] = "07:30:00";
      orderConfirmationRequest["end_time"] = slotTiming.to_time;
      // orderConfirmationRequest["end_time"] = "07:45:00";
      orderConfirmationRequest["chiss_transaction_id"] = slotTiming.transaction_id;
      // orderConfirmationRequest["chiss_transaction_id"] = "1712901169361633861";
      orderConfirmationRequest["role_id"] = window.localStorage.getItem('role');
      orderConfirmationRequest["status"] = "2";
      orderConfirmationRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
      orderConfirmationRequest["type"] = "post";
      orderConfirmationRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
      this.SpinnerService.show()
      this.omsServiceService.orderConfirmation(orderConfirmationRequest).subscribe(
        (res) => {
          this.SpinnerService.hide()
          if (res["status"] == 1) {
          this.isConfirmedOrder = false;
          this.isSuccessMsg =true;
            this.msg= res["message"];
              this.toastr.success(res["message"]);
          } else {
            this.msg= res["message"];
            this.isFailureMsg =true;
            this.toastr.error(res["message"]);
          }
          this.SpinnerService.hide();
        this.modal.close();
        });

    }else{
      this.toastr.error("Slots are not availble please try with different dates");
    }
  }


  reScheduleOrder(dateEntered, slotTiming) {

    this.msg="";
    this.isFailureMsg=false;
    this.isSuccessMsg=false;
    if (this.reasonType != "" && this.reasonType != null && this.reasonType != undefined) {
      if (this.subReasonType != "" && this.subReasonType != null && this.subReasonType != undefined) {


        if (dateEntered != "" && dateEntered != null && dateEntered != undefined) {
          if (slotTiming != "" && slotTiming != null && slotTiming != undefined) {
            this.isFormValid = true;
          } else {
            // alert("please select slot");
            this.toastr.error("please select slot");

          }
        } else {
          // alert("please select schedule date");
          this.toastr.error("please select schedule date");
        }

      } else {
        // alert("please select sub reason type");
        this.toastr.error("please select sub reason type");
      }
    } else {
      // alert("please select reason type");
      this.toastr.error("please select reason type");
    }
    if (this.isFormValid) {

      let reScheduleOrderRequest = {};
      let fromDate = dateEntered;
      let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
      let scheduledDate = this.sharedService.getStringDate(new Date(fromDateValue));
      reScheduleOrderRequest["order_id"] = this.order_id;
      reScheduleOrderRequest["actionById"] = window.localStorage.getItem('actionById');
      reScheduleOrderRequest["actionByName"] = window.localStorage.getItem('actionByName');
      reScheduleOrderRequest["source"] = this.constantsService.SOURCE;
      reScheduleOrderRequest["reasonType"] = "Customer related";
      reScheduleOrderRequest["reason"] = this.reason;
      reScheduleOrderRequest["comment"] = "rescheduling";
      reScheduleOrderRequest["scheduled_date"] = scheduledDate;
      reScheduleOrderRequest["latitude"] = this.delivery_lat;
      reScheduleOrderRequest["longitude"] = this.delivery_lng;
      reScheduleOrderRequest["start_time"] = slotTiming.from_time;
      reScheduleOrderRequest["end_time"] = slotTiming.to_time;
      reScheduleOrderRequest["retained"] = this.constantsService.RETAINED;
      reScheduleOrderRequest["role_id"] = window.localStorage.getItem('role');

      reScheduleOrderRequest["status"] = this.constantsService.STATUS;
      //7
      //reScheduleOrderRequest["category_id"] = this.constantsService.CATEGORY_ID;
      reScheduleOrderRequest["category_id"] = this.reasonType;
      //reScheduleOrderRequest["sub_category_id"] = this.constantsService.SUB_CATEGORY_ID;
      reScheduleOrderRequest["sub_category_id"] = this.subReasonType;
      reScheduleOrderRequest["chiss_transaction_id"] = slotTiming.transaction_id;

      reScheduleOrderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
      if(window.localStorage.getItem('role') =="42")
      {
        reScheduleOrderRequest["skipChissCall"] = 1;
      }      
      reScheduleOrderRequest["method"] = "OMS/api/operation.php/v1/order/change/status";
      reScheduleOrderRequest["type"] = "post";
     // reScheduleOrderRequest["skipChissCall"] = 0;
      this.SpinnerService.show();
      this.omsServiceService.reScheduleOrder(reScheduleOrderRequest).subscribe(
        (res) => {
          //console.log(res);
          if (res["status"] == 1) {
           // alert(res["message"]);
            this.msg=res["message"];
            this.isSuccessMsg =true;
            this.isReScheduleOrder = false;
            this.toastr.success(res["message"]);
          } else {
            this.msg=res["message"];
            this.isFailureMsg =true;
            this.toastr.error(res["message"]);
            //alert(res["message"]);
          }
          //this.confirmOrderResponse = res.message;
          // this.isConfirmedOrder = true;
          this.modal.close();
          //this.orderDetailsPage(this.order_id);
          this.SpinnerService.hide();
        });

    }


  }


  submitReqModal(reqstatus) {
    console.log(this.order_id);
      if(reqstatus == 15){
        this.statusComment = 'Requested for Cancel';
      }else if(reqstatus == 16){
        this.statusComment = 'Request for re-schedule';
      }
      let confirmRequest = {};
      confirmRequest["method"] = "OMS/api/operation.php/v1/order/change/status";
      confirmRequest["type"] = "POST";
      confirmRequest["order_id"] = this.order_id;
      confirmRequest["actionById"] = window.localStorage.getItem('actionById');
      confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');;
      confirmRequest["source"] = this.constantsService.SOURCE;
      confirmRequest["comment"] = this.statusComment;
      confirmRequest["reason"] = this.reason;
      confirmRequest["role_id"] = window.localStorage.getItem('role');
      confirmRequest["status"] = reqstatus;
      confirmRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
      this.SpinnerService.show();
      this.omsServiceService.orderComplete(confirmRequest).subscribe(
        (res) => {

          if(res["status"]==1)
          {
          this.isSuccessMsg =true;
          this.toastr.success(res["message"]);
          this.modal.close(); 
          }else{
            this.isFailureMsg =true;
            this.toastr.error(res["message"]);
          }
          this.SpinnerService.hide();
        }

      )
  }

  submitCancelModal() {
    console.log(this.order_id);
    this.statusComment="Cancel Order";
      let confirmRequest = {};
      confirmRequest["method"] = "OMS/api/operation.php/v1/orders/cancel/manually";
      confirmRequest["type"] = "POST";
      // confirmRequest["order_ids"] = this.order_id;
      confirmRequest["actionById"] = window.localStorage.getItem('actionById');
      confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');;
      confirmRequest["comment"] = this.statusComment;
      confirmRequest["reason"] = this.reason;
      confirmRequest["refund_amount"] = this.amount+"";
      confirmRequest["isInternalCall"] = 1;
      if(window.location.pathname.includes('/escalation-details/')){
        confirmRequest["order_ids"] =[ this.order_id];
      }else{
        confirmRequest["order_ids"] = this.order_id;
      }
      this.SpinnerService.show();
      this.omsServiceService.orderComplete(confirmRequest).subscribe(
        (res) => {

          if(res["status"]==1)
          {
          this.isSuccessMsg =true;
          this.toastr.success(res["msg"][0]['msg']);
          this.modal.close(); 
          }else{
            this.isFailureMsg =true;
            this.toastr.error(res["msg"]);
          }
          this.SpinnerService.hide();
        }

      )
  }

  validateAmount() {
    // This function can be used for any additional logic if needed
  }

  getAllCancelationReasons() {
    let orderCancelReasonRequest = {};
    orderCancelReasonRequest["source"] = "CP";
    orderCancelReasonRequest["entity"] = "reschedule";
    orderCancelReasonRequest["tenantCode"] = this.orderObj.tenantCode;
    orderCancelReasonRequest["orgCode"] = this.orderObj.orgCode;

    orderCancelReasonRequest["method"] = "fetchservice/getCancellationRescheduleTypes";
    orderCancelReasonRequest["type"] = "post";

    //getCancelTypes
    this.omsServiceService.getCancelTypes(orderCancelReasonRequest).subscribe(
      (res) => {

        if (res["status"] == "success") {
          this.orderCancelTypes = res["data"];

        }


      }
    )
  }

  getSubType(type) {

    this.getAllCancelationSubReasons(type);

  }

  getAllCancelationSubReasons(obj) {
    let orderCancelReasonRequest = {};
    orderCancelReasonRequest["source"] = "CP";
    orderCancelReasonRequest["entity"] = "reschedule";
    orderCancelReasonRequest["tenantCode"] = this.orderObj.tenantCode;
    orderCancelReasonRequest["orgCode"] = this.orderObj.orgCode;
    orderCancelReasonRequest["typeId"] = obj;
    orderCancelReasonRequest["method"] = "fetchservice/getCancellationRescheduleTypes";
    orderCancelReasonRequest["type"] = "post";


    this.omsServiceService.getCancelTypes(orderCancelReasonRequest).subscribe(
      (res) => {

        if (res["status"] == "success") {
          this.orderCancelSubTypes = res["data"].subTypes;
          //console.log(this.orderCancelTypes);
        }


      }
    )
  }

  modelClose()
  {

    this.modal.close();
   // this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
  }

  selectedDate(dob) {
    if (dob) {
      const [year, month, day] = dob.split('-');
      const obj = { year: parseInt(year), month: parseInt(month), day: 
        parseInt(day.split(' ')[0].trim()) };
      this.from_date = obj;
      }
    }

    timeSlotInfo(timeSlot) {
      this.slotResponse.forEach((data:any)=>{
        if(data.from_time == timeSlot){
        this.slotTimingInfo = data;
        console.log('getting slotTimingInfo'+ JSON.stringify(this.slotTimingInfo));
        }
      })
    }

}
